import { ModelSagres } from "../../model-sagres"

export class PrestacaoDeContasLRFCI extends ModelSagres {
    IdPrestcontasLrfci: number
    Ano: number
    DataEntrega: Date
    DataSituacao: Date
    IdStatusPc: number
    UsuarioEntrega: string
    CodArquivo: number
    IdUnidgestRelatorio: number

    /**
     * Trata os dados recebidos pela API. Não execute em outras situações
     * @since 20220613
     */
    tratarDadosDaAPI(): void {
        /* if (typeof (this as any).Ref !== 'undefined') {
            this.Referencia = (this as any).Ref
        } */
        if (this.DataEntrega) {
            this.DataEntrega = new Date(this.DataEntrega)
        }
        if (this.DataSituacao) {
            this.DataSituacao = new Date(this.DataSituacao)
        }
    }
}